<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-categoria') {
            next({ name: 'ven-categoria-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-categoria') {
            this.$router.push({ name: 'ven-categoria-list' });
        }
    },
};
</script>
